import { Chip, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getDurationColor } from '../../../utils';

export type TermChipVariant = 'default' | 'bordered';

// Bordered design (goals-step revamp table only): per-term border + fill from the Figma spec.
// success2 (var(--bg-success-2)) comes from the theme; the rest are fixed design tokens.
const getBorderedTermStyle = (theme: any, term: string) => {
    const lowerDur = term.toLowerCase();
    if (lowerDur.includes('short')) return { border: '1px solid #2D1249', background: '#D3C5E2' }; // need these colors on theme palette
    if (lowerDur.includes('medium'))
        return {
            border: '1px solid #005135', // bd/medium — need these colors on theme palette
            background: `linear-gradient(0deg, #ABC8CC 0%, #ABC8CC 100%), ${theme.palette.semantic.bg.success2}`
        };
    if (lowerDur.includes('long')) return { border: '1px solid #00175C', background: '#B2C0EA' }; // need these colors on theme palette
    return {};
};

// Small pill showing the term (e.g. "Short", "Medium", "Long") colour-coded by duration.
export const TermChip = ({ term, variant = 'default' }: { term?: string; variant?: TermChipVariant }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    if (!term) return null;
    const borderedSx = {
        height: '24px',
        borderRadius: '100px',
        fontWeight: 400,
        fontSize: '12px',
        lineHeight: '17px',
        color: theme.palette.semantic.text.default,
        ...getBorderedTermStyle(theme, term),
        '& .MuiChip-label': { padding: '0 11px' }
    };
    const defaultSx = {
        backgroundColor: getDurationColor(theme, term),
        fontWeight: 600,
        minWidth: '100px',
        borderRadius: '16px'
    };
    return (
        <Chip
            label={t(term.split(' ')[0].toUpperCase())}
            size="small"
            sx={variant === 'bordered' ? borderedSx : defaultSx}
        />
    );
};
